import { baseApi, CONVERSION_PAIRS_TAG } from '@/shared';
import {
  conversionPairsAdapter,
  conversionPairRateAdapter,
} from '../utils/helpers/adapter';

import type {
  TConversionPair,
  TConversionPairRate,
  TGetConversionPairRateParams,
  TConversionPairCreateParams,
  TConversionPairUpdateParams,
  TConversionPairDeleteParams,
  TConversionPairRefreshParams,
} from './types';

export const conversionPairsApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getConversionPairs: build.query<TConversionPair[], void>({
      query: () => ({
        url: '/admin/conversion_pairs/list',
      }),
      transformResponse: conversionPairsAdapter,
      providesTags: [CONVERSION_PAIRS_TAG],
    }),

    getConversionPairRate: build.query<TConversionPairRate, TGetConversionPairRateParams>({
      query: ({ baseCurrency, quoteCurrency }) => ({
        url: `/admin/conversion_pairs/rate/${baseCurrency}/${quoteCurrency}`,
      }),
      transformResponse: conversionPairRateAdapter,
    }),

    createConversionPair: build.mutation<void, TConversionPairCreateParams>({
      query: (params) => ({
        url: '/admin/conversion_pairs/create',
        method: 'POST',
        body: {
          base_currency: params.baseCurrency,
          quote_currency: params.quoteCurrency,
          rate: params.rate,
          markup_percent: params.markupPercent,
          auto_refresh: params.autoRefresh,
        },
      }),
      invalidatesTags: [CONVERSION_PAIRS_TAG],
    }),

    updateConversionPair: build.mutation<void, TConversionPairUpdateParams>({
      query: ({ pairId, ...params }) => ({
        url: `/admin/conversion_pairs/update/${pairId}`,
        method: 'PUT',
        body: {
          rate: params.rate,
          markup_percent: params.markupPercent,
          auto_refresh: params.autoRefresh,
        },
      }),
      invalidatesTags: [CONVERSION_PAIRS_TAG],
    }),

    refreshConversionPair: build.mutation<void, TConversionPairRefreshParams>({
      query: ({ pairId }) => ({
        url: `/admin/conversion_pairs/refresh/${pairId}`,
        method: 'POST',
      }),
      invalidatesTags: [CONVERSION_PAIRS_TAG],
    }),

    deleteConversionPair: build.mutation<void, TConversionPairDeleteParams>({
      query: ({ pairId }) => ({
        url: `/admin/conversion_pairs/delete/${pairId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CONVERSION_PAIRS_TAG],
    }),

  }),
});

export const {
  useGetConversionPairsQuery,
  useGetConversionPairRateQuery,
  useCreateConversionPairMutation,
  useUpdateConversionPairMutation,
  useRefreshConversionPairMutation,
  useDeleteConversionPairMutation,
} = conversionPairsApi;
